import React, {} from 'react';
const ModalHeader = ({ children, show = true }) => {
    if (!show) {
        return null;
    }
    return React.createElement("div", { className: "modal-header" }, children);
};
export default ModalHeader;
